import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React from "react";
import { Stepper, Step, StepLabel, QontoConnector, QontoStepIcon, TemplateProjectForm, B2BProjectForm, B2CProjectForm, ChipGroup, Grid, Button, TextField, Slide, AddTaskForm, SubmitButton } from "../../..";
import { Field } from "formik";
import selects from "../../../assets/selects";

var StepperHorizontal = function StepperHorizontal(props) {
  var _React$useState = React.useState(props.step || 0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      activeStep = _React$useState2[0],
      setActiveStep = _React$useState2[1];

  var _React$useState3 = React.useState("left"),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      directionStep = _React$useState4[0],
      setDirectionStep = _React$useState4[1]; // const classes = useStyles();


  var errors = props.errors,
      values = props.values,
      translation = props.translation,
      setFieldValue = props.setFieldValue,
      isValid = props.isValid,
      isSubmitting = props.isSubmitting,
      currency = props.currency,
      fromBestPractice = props.fromBestPractice,
      template = props.template; // console.log("StepperHorizontal values", values);
  // console.log("StepperHorizontal fromBestPractice", fromBestPractice);

  var steps,
      contentSteps = [],
      finalButton,
      actionsStepper; // Funcion avanzar

  var handleNext = function handleNext() {
    setDirectionStep("left");
    setActiveStep(function (prevActiveStep) {
      return prevActiveStep + 1;
    });
  }; // Funcion retroceder


  var handleBack = function handleBack() {
    setDirectionStep("right");
    setActiveStep(function (prevActiveStep) {
      return prevActiveStep - 1;
    });
  };

  var handleReturn = function handleReturn() {// console.log("volver");
    //props.onReturn();
  }; // Función finalizar Stepper


  var handleFinish = function handleFinish() {
    props.onClickSubmit();
  }; // Creación predeterminada de steps en funcion del variant recibido


  switch (props.variant) {
    case "project":
      steps = fromBestPractice ? translation ? translation.steps.slice(0, 2).map(function (step) {
        return step.label;
      }) : selects.add_project_steps.slice(0, 2) : translation ? translation.steps.map(function (step) {
        return step.label;
      }) : selects.add_project_steps;
      contentSteps.push( /*#__PURE__*/React.createElement(Grid, {
        item: true,
        md: 12
      }, /*#__PURE__*/React.createElement(Field, {
        name: "projectType",
        component: ChipGroup,
        label: translation ? translation.selects.project_type.placeholder : "Project type",
        margin: "normal",
        value: values.projectType,
        options: translation ? translation.selects.project_type.items : selects.project_type,
        clickable: props.variant !== "view"
      }))); // console.log("values stepper", values);

      values.projectType === "b2b" ? contentSteps[1] = /*#__PURE__*/React.createElement(B2BProjectForm, {
        values: values,
        mode: "add",
        currency: currency,
        translation: translation ? translation : null,
        contacts: props.contacts,
        opportunities: props.opportunities,
        fillForm: function fillForm(value) {
          // console.log('fillForm', value)
          props.fillFormHandler(value, setFieldValue, values);
        },
        fromBestPractice: fromBestPractice
      }) : contentSteps[1] = /*#__PURE__*/React.createElement(B2CProjectForm, {
        values: values,
        mode: "add",
        translation: translation ? translation : null,
        contacts: props.contacts,
        fromBestPractice: fromBestPractice
      });
      contentSteps[2] = !fromBestPractice && /*#__PURE__*/React.createElement(TemplateProjectForm, {
        values: values,
        value: fromBestPractice ? template.id : values.template,
        label: translation ? translation.selects.template.placeholder : "Select a template for your project",
        mode: "add",
        templates: props.templates && props.templates.filter(function (template) {
          return template.type === values.type;
        })
      });
      actionsStepper = [/*#__PURE__*/React.createElement(Grid, {
        container: true,
        spacing: 2
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6
      }), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6
      }, /*#__PURE__*/React.createElement(Button, {
        disabled: !values.hasOwnProperty("projectType"),
        fullWidth: true,
        variant: "contained",
        color: "primary",
        onClick: function onClick() {
          props.handleTypeProject(values.projectType);
          handleNext();
        }
      }, translation ? translation.buttons.next : "Next"))), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        spacing: 2
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6
      }, /*#__PURE__*/React.createElement(Button, {
        fullWidth: true,
        variant: "outlined",
        onClick: handleBack
      }, translation ? translation.buttons.back : "Back")), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6
      }, /*#__PURE__*/React.createElement(Button, {
        fullWidth: true,
        variant: "contained",
        color: "primary",
        type: fromBestPractice ? "submit" : "button",
        onClick: function onClick() {
          if (!fromBestPractice) {
            values.template = "";
            handleNext();
          }
        },
        disabled: !fromBestPractice ? values.projectType === "b2b" ? !values.hasOwnProperty("name") || errors.hasOwnProperty("name") || errors.hasOwnProperty("dateStart") || errors.hasOwnProperty("dateEnd") || errors.hasOwnProperty("type") || errors.hasOwnProperty("budget") || errors.hasOwnProperty("currency") ? true : false : values.projectType === "b2c" ? !values.hasOwnProperty("name") || errors.hasOwnProperty("name") || errors.hasOwnProperty("dateStart") || errors.hasOwnProperty("dateEnd") || errors.hasOwnProperty("contact") || errors.hasOwnProperty("type") || errors.hasOwnProperty("budget") || errors.hasOwnProperty("currency") ? true : false : true : !isValid || isSubmitting
      }, fromBestPractice ? translation ? translation.buttons.save : "Save" : translation ? translation.buttons.next : "Next"))), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        spacing: 2
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6
      }, /*#__PURE__*/React.createElement(Button, {
        fullWidth: true,
        variant: "outlined",
        onClick: handleBack
      }, translation ? translation.buttons.back : "Back")), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "primary" //onClick={handleFinish}
        ,
        fullWidth: true,
        type: "submit",
        disabled: !isValid || isSubmitting
      }, translation ? translation.buttons.finish : "Save")))];
      break;

    case "projectAddInsideTask":
      steps = translation ? translation.steps.map(function (step) {
        return step.label;
      }) : selects.add_task_steps;
      contentSteps.push( /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Field, {
        name: "nameParent",
        component: TextField,
        label: translation ? translation.inputs.name_parent : "Group title",
        fullWidth: true,
        margin: "normal",
        value: values.nameParent
      })));
      contentSteps.push( /*#__PURE__*/React.createElement(AddTaskForm, {
        values: values,
        mode: "add",
        translation: translation ? translation : null
      }));
      actionsStepper = [/*#__PURE__*/React.createElement(Grid, {
        container: true,
        spacing: 2
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6
      }), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6
      }, /*#__PURE__*/React.createElement(Button //   disabled={!values.hasOwnProperty("projectType")}
      , {
        fullWidth: true,
        variant: "contained",
        color: "primary",
        onClick: function onClick() {
          handleNext();
        }
      }, translation ? translation.buttons.next : "Next"))), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        spacing: 2
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6
      }, /*#__PURE__*/React.createElement(Button, {
        fullWidth: true,
        variant: "outlined",
        onClick: handleBack
      }, translation ? translation.buttons.back : "Back")), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6
      }, /*#__PURE__*/React.createElement(Button, {
        fullWidth: true,
        variant: "contained",
        color: "primary",
        component: SubmitButton,
        type: "submit" //   disabled={!isValid && isSubmitting}

      }, translation ? translation.buttons.finish : "Next")))];
      break;

    default:
      steps = ["TEST 0", "TEST 1", "TEST 2"];
      contentSteps = [/*#__PURE__*/React.createElement(Slide, {
        direction: directionStep,
        "in": true,
        mountOnEnter: true,
        unmountOnExit: true,
        key: "slide_step_0"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TextField, {
        variant: "outlined",
        margin: "normal",
        fullWidth: true,
        name: "test",
        label: "label test0",
        type: "text",
        id: "test_id",
        value: "value 0" // onChange={props.input1.onChange}
        ,
        required: true,
        autoFocus: true
      }))), /*#__PURE__*/React.createElement(Slide, {
        direction: directionStep,
        "in": true,
        mountOnEnter: true,
        unmountOnExit: true,
        key: "slide_step_1"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TextField, {
        variant: "outlined",
        margin: "normal",
        fullWidth: true,
        name: "test",
        label: "label test1",
        type: "text",
        id: "test_id",
        value: "value 1" // onChange={props.input1.onChange}
        ,
        required: true,
        autoFocus: true
      }))), /*#__PURE__*/React.createElement(Slide, {
        direction: directionStep,
        "in": true,
        mountOnEnter: true,
        unmountOnExit: true,
        key: "slide_step_2"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TextField, {
        variant: "outlined",
        margin: "normal",
        fullWidth: true,
        name: "test",
        label: "label test2",
        type: "text",
        id: "test_id",
        value: "value 2",
        required: true,
        autoFocus: true
      })))];
      finalButton = translation ? translation.buttons.save : "Save";
      actionsStepper = /*#__PURE__*/React.createElement(Grid, {
        container: true,
        spacing: 2
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6
      }, activeStep === 0 ? /*#__PURE__*/React.createElement(Button, {
        fullWidth: true,
        variant: "outlined",
        onClick: handleReturn // className={classes.button}

      }, translation ? translation.buttons.back : "Back") : /*#__PURE__*/React.createElement(Button, {
        fullWidth: true,
        variant: "outlined",
        onClick: handleBack // className={classes.button}

      }, translation ? translation.buttons.back : "Back")), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6
      }, activeStep === steps.length - 1 ? /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "primary",
        onClick: handleFinish // className={classes.button}
        ,
        fullWidth: true
      }, finalButton) : /*#__PURE__*/React.createElement(Button, {
        fullWidth: true,
        variant: "contained",
        color: "primary",
        onClick: handleNext // className={classes.button}

      }, translation ? translation.buttons.next : "Next")));
      break;
  }

  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    justify: "center"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Stepper, {
    alternativeLabel: true,
    activeStep: activeStep,
    connector: /*#__PURE__*/React.createElement(QontoConnector, null)
  }, steps.map(function (label) {
    return /*#__PURE__*/React.createElement(Step, {
      key: label
    }, /*#__PURE__*/React.createElement(StepLabel, {
      StepIconComponent: QontoStepIcon
    }, label));
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, contentSteps[activeStep]), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    style: {
      marginTop: "16px"
    }
  }, actionsStepper[activeStep]));
};

export { StepperHorizontal };